module.exports = __webpack_public_path__ + "media/images/icon-interconnexion-job-ec0b22ca4d9f89501916e5be2b5a821e.png";